module.exports = __webpack_public_path__ + "media/images/ui-icons_cc0000_256x240-bd6996f9.png";